import React, { useEffect, useRef } from 'react';
import { createChart, CandlestickSeries } from 'lightweight-charts';

const TestChart = () => {
  const chartContainerRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    const chartContainer = chartContainerRef.current;

    const chart = createChart(chartContainer, {
      width: chartContainer.clientWidth,
      height: 400,
      layout: {
        background: { color: '#000000' },
        textColor: '#FFFFFF',
      },
      grid: {
        vertLines: { color: '#333' },
        horzLines: { color: '#333' },
      },
      timeScale: {
        borderColor: '#485c7b',
        timeVisible: true,
        secondsVisible: false,
      },
    });

    const series = chart.addSeries(CandlestickSeries, {
      upColor: '#2ECC71',
      downColor: '#E74C3C',
      borderVisible: false,
      wickUpColor: '#2ECC71',
      wickDownColor: '#E74C3C',
    });

    const data = [
      {
        time: Math.floor(Date.now() / 1000) - 86400 * 3,
        open: 100,
        high: 110,
        low: 90,
        close: 105,
      },
      {
        time: Math.floor(Date.now() / 1000) - 86400 * 2,
        open: 105,
        high: 115,
        low: 95,
        close: 110,
      },
      {
        time: Math.floor(Date.now() / 1000) - 86400,
        open: 110,
        high: 120,
        low: 100,
        close: 115,
      },
    ];

    series.setData(data);

    // ✅ Auto fit to candles
    chart.timeScale().fitContent();

    chartRef.current = chart;

    return () => {
      if (chartRef.current) {
        chartRef.current.remove();
        chartRef.current = null;
      }
    };
  }, []);

  return (
    <div
      ref={chartContainerRef}
      style={{
        width: '100%',
        maxWidth: '700px',
        height: '400px',
        margin: '0 auto',
      }}
    />
  );
};

export default TestChart;
